module.exports = __webpack_public_path__ + "img/banner.2c4750b0.png";